import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Form, Input, Button, Alert, Card, Typography } from 'antd';
import Ink from 'react-ink';
import { accountId, api } from '../../config';

import './login.css';

import {
	userLogin
} from '../../modules/user';


import { MailOutlined, LockOutlined } from '@ant-design/icons';

const FormItem = Form.Item;
const { Text } = Typography;

class LoginCard extends Component {

	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			message: null,
			showOTP: false,
            email: '',
            password: '',
		}
	}

	componentDidMount() {
    let params = new URL(document.location.toString()).searchParams;
    if(params.get("auth_token")){
      this.props.userLogin({auth_token: params.get("auth_token")}).then(
        (res) => {
					window.parent.location = `${window.parent.location.origin}/`;
        },
        (err) => {
					window.parent.location = `${window.parent.location.origin}/login`;
        }
      );
    }
	}

	handleSubmit = (values) => {
        const { userSessionTimeout } = this.props;
        const { showOTP } = this.state;
        this.setState({ loading: true });
        
        // Store email and password for potential OTP resend
        if (!showOTP) {
            this.setState({
                email: values.email,
                password: values.password
            });
        }

        const apiDomain = api;
        localStorage.setItem('apiDomain', apiDomain);
        
        // If OTP is showing, include it in the request
        const loginData = showOTP 
            ? { email: this.state.email, password: this.state.password, OTP: values.otp }
            : values;
            
        this.props.userLogin(loginData).then(
            (res) => {
				this.setState({ loading: false, message: null });
				if (this.formRef.current) {
					this.formRef.current.resetFields();
				}
				if(!userSessionTimeout){
					window.parent.location = `${window.parent.location.origin}`;
				}
            },
            (err) => {
				console.log('err', err.response);
                // Check if the error is related to OTP
                if (err?.response?.data?.message === "OTP is required") {
                    this.setState({ 
                        loading: false, 
                        showOTP: true, 
                        message: "An OTP has been sent to your email. It will expire in 5 minutes."
                    });
                    if (this.formRef.current) {
                        this.formRef.current.resetFields(['password']);
                    }
                } else {
                    this.setState({ loading: false, message: `Please check Username/Password and try again.` });
                }
            }
        );
    }

	resendOTP = () => {
        const { email, password } = this.state;
        this.setState({ loading: true });
        
        this.props.userLogin({ email, password }).then(
            () => {
                // This should fail with OTP required
            },
            (err) => {
                if (err && err.message === "OTP is required") {
                    this.setState({ 
                        loading: false, 
                        message: "A new OTP has been sent to your email. It will expire in 5 minutes."
                    });
                    if (this.formRef.current) {
                        this.formRef.current.resetFields(['otp']);
                    }
                } else {
                    this.setState({ loading: false, message: `Error resending OTP. Please try again.` });
                }
            }
        );
    }

	goBackToLogin = () => {
        this.setState({ 
            showOTP: false, 
            message: null 
        });
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
    }

	render() {
		const { loading, message, showOTP } = this.state;
		const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
		return (
			<Card className="loginHolder">
				<h3 className="title"><LockOutlined /> Sign In - {capitalizeFirstLetter(accountId)}</h3>
				<Form ref={this.formRef} name="myForm" onFinish={this.handleSubmit} className="login-form">
					<div className="contentHolder">
						{(message) ? <Alert message={message} type={showOTP ? "info" : "error"} style={{ marginBottom: '20px' }} showIcon /> : ""}
						
						{!showOTP ? (
							<>
								<FormItem name='email' rules={[{ type: 'email', message: 'Please input a valid E-mail!' },
								{ required: true, message: 'Please input your username!' }]}>
									<Input style={{ borderLeft: "0px", borderRight: "0px", borderTop: "0px" }} size="large" prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="E-mail" />
								</FormItem>
								<FormItem name='password' rules={[{ required: true, message: 'Please input your Password!' }]}>
									<Input style={{ borderLeft: "0px", borderRight: "0px", borderTop: "0px" }} size="large" prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
								</FormItem>
							</>
						) : (
							<div className="otpContainer">
								<Text>Enter the verification code sent to your email</Text>
								<FormItem name='otp' rules={[{ required: true, message: 'Please input the OTP!' }]}>
									<Input.OTP style={{ marginTop: "15px" }} size="large" length={6} />
								</FormItem>
								<Button type="link" onClick={this.resendOTP} disabled={loading}>
									Resend verification code
								</Button>
							</div>
						)}
					</div>
					<div className="btnHolder">
						<Button type="primary" htmlType="submit" className="login-form-button" loading={loading}>
							{showOTP ? "Verify" : "Login"}
							<Ink />
						</Button>
						{showOTP && (
							<Button type="link" onClick={this.goBackToLogin} className="back-button">
								Back to login
							</Button>
						)}
					</div>
				</Form>
			</Card>
		);
	}
}

const mapStateToProps = state => ({
	userAuthenticated: state.user.userAuthenticated
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userLogin
		},
		dispatch
	);


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginCard));
